(() => {
  'use strict';
  if (window.PDSProductInformation) { window.PDSProductInformation.init(document); return; }
  function init(scope) {
    const roots = [...scope.querySelectorAll('[data-pds-info]')];
    if (scope.matches?.('[data-pds-info]')) roots.unshift(scope);
    roots.forEach(root => {
      if (root.dataset.enhanced) return;
      const list = root.querySelector('[data-info-tabs]');
      const tabs = [...root.querySelectorAll('[data-info-tab]')];
      const panels = [...root.querySelectorAll('[data-info-panel]')];
      if (!list || tabs.length !== panels.length || !tabs.every(tab => panels.some(panel => panel.id === tab.dataset.infoTab))) return;
      function select(tab, focus = false) {
        tabs.forEach(item => {
          const active = item === tab;
          item.setAttribute('aria-selected', String(active));
          item.tabIndex = active ? 0 : -1;
          panels.find(panel => panel.id === item.dataset.infoTab).hidden = !active;
        });
        if (focus) tab.focus({ preventScroll: true });
        // Scroll only the tab strip, never the page or a sticky header.
        const box = tab.getBoundingClientRect(), frame = list.getBoundingClientRect();
        if (box.left < frame.left + 4) list.scrollLeft += box.left - frame.left - 4;
        else if (box.right > frame.right - 4) list.scrollLeft += box.right - frame.right + 4;
      }
      list.setAttribute('role', 'tablist');
      list.setAttribute('aria-orientation', 'horizontal');
      tabs.forEach((tab, index) => {
        tab.setAttribute('role', 'tab');
        tab.setAttribute('aria-controls', tab.dataset.infoTab);
        const panel = panels.find(item => item.id === tab.dataset.infoTab);
        panel.setAttribute('role', 'tabpanel');
        panel.setAttribute('aria-labelledby', tab.id);
        panel.tabIndex = 0;
        tab.addEventListener('click', () => select(tab));
        tab.addEventListener('keydown', event => {
          let next;
          if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
          else if (event.key === 'ArrowLeft') next = (index - 1 + tabs.length) % tabs.length;
          else if (event.key === 'Home') next = 0;
          else if (event.key === 'End') next = tabs.length - 1;
          else return;
          event.preventDefault(); select(tabs[next], true);
        });
      });
      root.dataset.enhanced = 'true';
      list.hidden = false;
      select(tabs[0]);
    });
  }
  window.PDSProductInformation = { init };
  init(document);
  // Native high-variant selection replaces its product section with fresh server HTML.
  // Enhance the new details without changing that resolver or intercepting its events.
  const observer = new MutationObserver(records => {
    for (const record of records) for (const node of record.addedNodes) {
      if (node.nodeType === 1 && (node.matches('[data-pds-info]') || node.querySelector('[data-pds-info]'))) init(node);
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
